// extracted by mini-css-extract-plugin
export default {"switch":"FosHS1","indicator":"BE7jRZ"};